
$(document).on(
  "sub_floattop rendered",
  {},
  function (event, uniqueId) {
    var $this = $("#" + uniqueId);
  
    $(".openMenu").click(function (e) {
      e.preventDefault();
      $(".list_menu").toggleClass("active");
    });
    // console.log(event);
    // console.log(uniqueId);
    
  }
);
